import React from "react"
import styled from "styled-components"
import { useTranslation } from "next-i18next"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Image from "next/image"
import { themeGet } from "@styled-system/theme-get"
import Heading from "@/common/components/_UI/Heading"

import Image1 from "@/common/assets/image/whyWorkHere/KryptoGO Cover.webp"
import Image2 from "@/common/assets/image/whyWorkHere/decision.webp"
import Image3 from "@/common/assets/image/whyWorkHere/Team_new.webp"

const IMAGE_DATA = [
  {
    title: "WhyWorkHere.img.1.title",
    img: Image1,
    content: "WhyWorkHere.img.1.content"
  },
  {
    title: "WhyWorkHere.img.2.title",
    img: Image2,
    content: "WhyWorkHere.img.2.content"
  },
  {
    title: "WhyWorkHere.img.3.title",
    img: Image3,
    content: "WhyWorkHere.img.3.content"
  }
]

export default function WhyWorkHere() {
  const { t } = useTranslation("joinUs")
  const settings = {
    className: "center",
    infinite: true,
    centerMode: true,
    enterPadding: "60px",
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 3500,
    cssEase: "linear",
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  }

  return (
    <Wrapper id="whyus">
      {/* <Heading content={t("WhyWorkHere.title1")}/> */}
      <Heading
        className="text-gradient text-glow title"
        content={t("WhyWorkHere.title2")}
      />
      <Slider {...settings} className="sliderTool">
        {IMAGE_DATA.map(({ title, img, content }) => (
          <div key={title}>
            <div className="sliderWrapper">
              <p className="sliderTitle">{t(title)}</p>
              <div className="sliderImg">
                <Image
                  src={img}
                  alt={title}
                  fill
                  sizes="100vw"
                  style={{
                    objectFit: "cover"
                  }}
                />
              </div>
            </div>
            <p className="desc">{t(content)}</p>
          </div>
        ))}
        {IMAGE_DATA.map(({ title, img, content }) => (
          <div key={title}>
            <div className="sliderWrapper">
              <p className="sliderTitle">{t(title)}</p>
              <div className="sliderImg">
                <Image
                  src={img}
                  alt={title}
                  fill
                  sizes="100vw"
                  style={{
                    objectFit: "cover"
                  }}
                />
              </div>
            </div>
            <p className="desc">{t(content)}</p>
          </div>
        ))}
        {IMAGE_DATA.map(({ title, img, content }) => (
          <div key={title}>
            <div className="sliderWrapper">
              <p className="sliderTitle">{t(title)}</p>
              <div className="sliderImg">
                <Image
                  src={img}
                  alt={title}
                  fill
                  sizes="100"
                  style={{
                    objectFit: "cover"
                  }}
                />
              </div>
            </div>
            <p className="desc">{t(content)}</p>
          </div>
        ))}
      </Slider>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow: hidden;
  padding-top: 84px;
  margin-top: -84px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    text-align: center;
  }
  .sliderTool {
    width: 100vw;
    margin-top: 52px;
    .slick-list {
      width: 100% !important;
      overflow: visible;
      .slick-track {
        display: flex;
        gap: 50px;
        @media (max-width: 500px) {
          gap: 20px;
        }
      }
    }
  }
  .slick-slide {
    transition: 1s;
    transform: translateX(calc(-50% - 25px));
    @media (max-width: 1000px) {
      transform: translateX(0);
    }
  }
  .sliderWrapper {
    position: relative;
    transition: all 0.3s;
    .sliderImg {
      border-radius: 20px;
      overflow: hidden;
      position: relative;
      width: 100%;
      height: 50vh;
      transition: 0.3s;
      &:after {
        content: "";
        width: 101%;
        height: 101%;
        top: 0px;
        left: 0px;
        position: absolute;
        transition: all 0.2s;
        background: linear-gradient(
          to top,
          ${themeGet("colors.background")} 0%,
          rgba(0, 0, 0, 0) 50%
        );
        opacity: 1;
        transform: translateY(80px) scale(1);
      }
    }
    .sliderTitle {
      position: absolute;
      -webkit-text-stroke: 0.8px ${themeGet("colors.primary")};
      background: linear-gradient(
        to right,
        ${themeGet("colors.primary")} 10%,
        #ffdf6b2d
      );
      background-clip: text;
      -webkit-background-clip: text;
      font-weight: 500;
      color: transparent;
      font-size: 50px;
      left: -10px;
      bottom: -20px;
      z-index: 888;
      line-height: 1.2;
      opacity: 0;
      transition: all 1s 0.5s;
      transform: translate(-10px, 0);
      /* &:before {
        content: "";
        position: absolute;
        background-color: #0000004a;
        width: 100%;
        height: 100%;
        z-index:-1;
        top: -10px;
        right: -10px;
        filter:blur(20px);
      } */
      @media (max-width: 1200px) {
        font-size: 32px;
      }
    }
  }
  .desc {
    color: ${themeGet("colors.primary")};
    opacity: 0;
    transition: 1s 1s;
    width: 100%;
    padding: 10px 0px;
  }
  .slick-current {
    transform: translateX(calc(-50% - 25px)) scale(1.05);
    transition: all 0.3;
    z-index: 30;
    .sliderWrapper {
      .sliderTitle {
        opacity: 1;
        transform: translate(0px, 0px);
      }
      .sliderImg {
        &:after {
          transform: translateY(0px) scale(1);
          opacity: 1;
        }
      }
    }
    .desc {
      color: ${themeGet("colors.primary")};
      opacity: 1;
    }
    @media (max-width: 1000px) {
      transform: translateX(0) scale(1.05);
    }
  }
`
